export function getSendFinanceSimulationMailEndpoint(destination: string): string {
    return `/request/send/finance-simulation/${destination}`;
}
